<template>
    <!-- 商户进件详情 -->
    <div class="merchantInfo">
        <div style="margin-bottom: 20px;">
            <el-button size="small" icon="el-icon-back" @click="$router.back()">返 回</el-button>
        </div>
        <!--企业商户-->
        <el-card v-if="merchanttype != 3" class="box-card" shadow="hover">
            <!-- 基础信息 -->
            <div>
                <div class="title">基础信息</div>
                <el-row :gutter="20">
                    <el-col :sm="20" :md="20" :lg="20">
                        <el-row>
                            <el-col :sm="12" :md="12" :lg="8">
                                <span class="labels">商户类型：</span>
                                <span>{{merchanttype == 1 ? '个体工商户':'企业商户'}}</span>
                            </el-col>
                            <el-col :sm="12" :md="12" :lg="8">
                                <span class="labels">商户名称：</span>
                                <span>{{baseInfo.merchant_name}}</span>
                            </el-col>
                            <el-col :sm="12" :md="12" :lg="8">
                                <span class="labels">商户简称：</span>
                                <span>{{baseInfo.name_abbr}}</span>
                            </el-col>
                            <el-col :sm="12" :md="12" :lg="8">
                                <span class="labels">经营范围：</span>
                                <span>{{baseInfo.biz_scope}}</span>
                            </el-col>
                            <el-col :sm="12" :md="12" :lg="8">
                                <span class="labels">省市区：</span>
                                <span>{{baseInfo.view_business_addr}}</span>
                            </el-col>
                            <el-col :sm="12" :md="12" :lg="8">
                                <span class="labels">详细地址：</span>
                                <span>{{baseInfo.addr_detail}}</span>
                            </el-col>
                            <el-col :sm="12" :md="12" :lg="8">
                                <span class="labels">法人姓名：</span>
                                <span>{{baseInfo.owner_name}}</span>
                            </el-col>
                            <el-col :sm="12" :md="12" :lg="8">
                                <span class="labels">证件号码：</span>
                                <span>{{baseInfo.owner_cert_id | desIdCard}}</span>
                            </el-col>
                            <el-col :sm="12" :md="12" :lg="8">
                                <span class="labels">证件有效期：</span>
                                <span>{{baseInfo.owner_cert_sdate}}至{{baseInfo.owner_cert_edate}}</span>
                            </el-col>
                            <el-col :sm="12" :md="12" :lg="8">
                                <span class="labels">法人手机号：</span>
                                <span>{{baseInfo.owner_mobile | desMobile}}</span>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
            <!-- 结算信息 -->
            <div>
                <div class="title">结算信息</div>
                <el-row :gutter="20">
                    <el-col :sm="20" :md="20" :lg="20">
                        <el-row>
                            <el-col :sm="12" :md="12" :lg="8">
                                <span class="labels">银行账户户名：</span>
                                <span>{{baseInfo.settle_acc_name}}</span>
                            </el-col>
                            <el-col :sm="12" :md="12" :lg="8">
                                <span class="labels">银行账户：</span>
                                <span>{{baseInfo.settle_acc_no | desIdCard}}</span>
                            </el-col>
                            <el-col :sm="12" :md="12" :lg="8">
                                <span class="labels">银行名称：</span>
                                <span>{{baseInfo.settle_bank_name}}</span>
                            </el-col>
                            <el-col :sm="12" :md="12" :lg="8">
                                <span class="labels">预留手机号：</span>
                                <span>{{baseInfo.owner_mobile | desMobile}}</span>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
            <div>
                <div class="title">资质信息</div>
                <el-row :gutter="20">
                    <el-col :sm="12" :md="12" :lg="6">
                        <span class="labels">身份证正面照：</span>
                        <span>
                            <el-button
                                type="text"
                                style="padding:0;font-size:12px"
                                @click="viewImage(baseInfo.card_positive_photo)"
                            >点击查看</el-button>
                        </span>
                    </el-col>
                    <el-col :sm="12" :md="12" :lg="6">
                        <span class="labels">身份证反面照：</span>
                        <span>
                            <el-button
                                type="text"
                                style="padding:0;font-size:12px"
                                @click="viewImage(baseInfo.card_negative_photo)"
                            >点击查看</el-button>
                        </span>
                    </el-col>
                    <el-col :sm="12" :md="12" :lg="6">
                        <span class="labels">手持证件照：</span>
                        <span>
                            <el-button
                                type="text"
                                style="padding:0;font-size:12px"
                                @click="viewImage(baseInfo.card_hand_hold_photo)"
                            >点击查看</el-button>
                        </span>
                    </el-col>
                    <el-col :sm="12" :md="12" :lg="6">
                        <span class="labels">结算卡照片：</span>
                        <span>
                            <el-button
                                type="text"
                                style="padding:0;font-size:12px"
                                @click="viewImage(baseInfo.settle_card_photo)"
                            >点击查看</el-button>
                        </span>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :sm="12" :md="12" :lg="6">
                        <span class="labels">营业执照：</span>
                        <span>
                            <el-button
                                type="text"
                                style="padding:0;font-size:12px"
                                @click="viewImage(baseInfo.license_photo)"
                            >点击查看</el-button>
                        </span>
                    </el-col>
                    <el-col :sm="12" :md="12" :lg="6" v-if="baseInfo.opening_permit_photo != undefined && baseInfo.opening_permit_photo.length > 10">
                        <span class="labels">开户许可证：</span>
                        <span>
                            <el-button
                                type="text"
                                style="padding:0;font-size:12px"
                                @click="viewImage(baseInfo.opening_permit_photo)"
                            >点击查看</el-button>
                        </span>
                    </el-col>
                </el-row>
            </div>
            <div>
                <el-row :gutter="20">
                    <el-col :sm="20" :md="20" :lg="20">
                        <el-row>
                            <el-col :sm="24" v-if="baseInfo.status == 3">
                                <div class="reason">拒绝原因：{{baseInfo.denial_reason}}</div>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
        </el-card>
        
        <!--小微商户-->
        <el-card v-if="merchanttype == 3" class="box-card" shadow="hover">
            <!-- 基础信息 -->
            <div>
                <div class="title">基础信息</div>
                <el-row :gutter="20">
                    <el-col :sm="20" :md="20" :lg="20">
                        <el-row>
                            <el-col :sm="12" :md="12" :lg="8">
                                <span class="labels">商户类型：</span>
                                <span>{{baseInfo.merchant_type}}</span>
                            </el-col>
                            <el-col :sm="12" :md="12" :lg="8">
                                <span class="labels">商户名称：</span>
                                <span>{{baseInfo.merchant_name}}</span>
                            </el-col>
                            <el-col :sm="12" :md="12" :lg="8">
                                <span class="labels">商户简称：</span>
                                <span>{{baseInfo.name_abbr}}</span>
                            </el-col>
                            <el-col :sm="12" :md="12" :lg="8">
                                <span class="labels">经营范围：</span>
                                <span>{{baseInfo.biz_scope}}</span>
                            </el-col>
                            <el-col :sm="12" :md="12" :lg="8">
                                <span class="labels">省市区：</span>
                                <span>{{baseInfo.view_business_addr}}</span>
                            </el-col>
                            <el-col :sm="12" :md="12" :lg="8">
                                <span class="labels">详细地址：</span>
                                <span>{{baseInfo.addr_detail}}</span>
                            </el-col>
                            <el-col :sm="12" :md="12" :lg="8">
                                <span class="labels">法人姓名：</span>
                                <span>{{baseInfo.owner_name}}</span>
                            </el-col>
                            <el-col :sm="12" :md="12" :lg="8">
                                <span class="labels">证件号码：</span>
                                <span>{{baseInfo.owner_cert_id | desIdCard}}</span>
                            </el-col>
                            <el-col :sm="12" :md="12" :lg="8">
                                <span class="labels">证件有效期：</span>
                                <span>{{baseInfo.owner_cert_sdate}}至{{baseInfo.owner_cert_edate}}</span>
                            </el-col>
                            <el-col :sm="12" :md="12" :lg="8">
                                <span class="labels">法人手机号：</span>
                                <span>{{baseInfo.owner_mobile | desMobile}}</span>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
            <!-- 结算信息 -->
            <div>
                <div class="title">结算信息</div>
                <el-row :gutter="20">
                    <el-col :sm="20" :md="20" :lg="20">
                        <el-row>
                            <el-col :sm="12" :md="12" :lg="8">
                                <span class="labels">银行账户户名：</span>
                                <span>{{baseInfo.settle_acc_name}}</span>
                            </el-col>
                            <el-col :sm="12" :md="12" :lg="8">
                                <span class="labels">银行账户：</span>
                                <span>{{baseInfo.settle_acc_no | desIdCard}}</span>
                            </el-col>
                            <el-col :sm="12" :md="12" :lg="8">
                                <span class="labels">银行名称：</span>
                                <span>{{baseInfo.settle_bank_name}}</span>
                            </el-col>
                            <el-col :sm="12" :md="12" :lg="8">
                                <span class="labels">预留手机号：</span>
                                <span>{{baseInfo.owner_mobile | desMobile}}</span>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
            <div>
                <div class="title">资质信息</div>
                <el-row :gutter="20">
                    <el-col :sm="12" :md="12" :lg="6">
                        <span class="labels">身份证正面照：</span>
                        <span>
                            <el-button
                                type="text"
                                style="padding:0;font-size:12px"
                                @click="viewImage(baseInfo.card_positive_photo)"
                            >点击查看</el-button>
                        </span>
                    </el-col>
                    <el-col :sm="12" :md="12" :lg="6">
                        <span class="labels">身份证反面照：</span>
                        <span>
                            <el-button
                                type="text"
                                style="padding:0;font-size:12px"
                                @click="viewImage(baseInfo.card_negative_photo)"
                            >点击查看</el-button>
                        </span>
                    </el-col>
                    <el-col :sm="12" :md="12" :lg="6">
                        <span class="labels">手持证件照：</span>
                        <span>
                            <el-button
                                type="text"
                                style="padding:0;font-size:12px"
                                @click="viewImage(baseInfo.card_hand_hold_photo)"
                            >点击查看</el-button>
                        </span>
                    </el-col>
                    <el-col :sm="12" :md="12" :lg="6">
                        <span class="labels">结算卡照片：</span>
                        <span>
                            <el-button
                                type="text"
                                style="padding:0;font-size:12px"
                                @click="viewImage(baseInfo.settle_card_photo)"
                            >点击查看</el-button>
                        </span>
                    </el-col>
                </el-row>
            </div>
            <div>
                <el-row :gutter="20">
                    <el-col :sm="20" :md="20" :lg="20">
                        <el-row>
                            <el-col :sm="24" v-if="baseInfo.status == 3">
                                <div class="reason">拒绝原因：{{baseInfo.denial_reason}}</div>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
        </el-card>
        <!-- 查看图片 -->
        <image-viwe v-if="picDialog" :onClose="handleCloseImgView" :urlList="[picUrl]"></image-viwe>
    </div>
</template>

<script>
import imageViwe from '../../../node_modules/element-ui/packages/image/src/image-viewer';

export default {
    name: "merchant-net-info",
    data() {
        return {
            picDialog: false, //查看图片
            picUrl: '',
            dialogImageUrl: '', //弹窗图片地址
            baseInfo: {},
            merchanttype: '',

        }
    },
    components: {
        imageViwe
    },
    mounted() {
        this.merchanttype = this.$route.query.merchant_type; //取商户类型
        this.$api.post('merchant_channel/findMerchantChannel', { id: this.$route.query.id, merchant_type: this.$route.query.merchant_type }, res => { //初始化
            let data = res.data;
            if (res.code == 0) {
                this.baseInfo = data;
            } else {
                this.$message.error(res.msg);
            }
        })
    },
    computed: {
        merchantClass() {
            let type
            switch (this.baseInfo.type) {
                case 1:
                    type = "个人商户";
                    break;
                case 2:
                    type = "企业商户";
                    break;
                default:
                    type = "小微商户"
                    break;
            }
            return type;
        }
    },
    methods: {
        viewImage(picUrl) { //查看图片
            if (picUrl != '') {
                this.picUrl = picUrl;
                this.picDialog = true;
            } else {
                this.$message.error('没有可以预览的图片哦！');
            }
        },
        handleCloseImgView() { //关闭图片
            this.picDialog = false;
            this.picUrl = '';
        },
    }
}
</script>

<style scoped lang="scss">
.merchantInfo {
    font-size: 12px;
    // ::v-deep .el-form-item__label {
    //     font-size: 12px;
    //     font-weight: 700;
    // }
    // ::v-deep .el-input__inner {
    //     width: 150px;
    // }
    .labels {
        font-weight: 700;
    }
    .title {
        margin: 10px 0;
        font-size: 13px;
        font-weight: 700;
        border-left: 5px solid #40b8ff;
        padding: 0 0 0 10px;
        .el-button--text {
            color: #303133;
            font-size: 13px;
            font-weight: 700;
        }
    }
    .el-row {
        margin: 10px 0;
        &:last-child {
            margin-bottom: 0;
        }
        .el-col {
            margin: 10px 0;
        }
    }
    // 滚动条
    ::v-deep
        .el-table--scrollable-y
        .el-table__body-wrapper::-webkit-scrollbar {
        width: 4px;
    }
    ::v-deep
        .el-table--scrollable-y
        .el-table__body-wrapper::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: rgba(0, 0, 0, 0.2);
    }
    ::v-deep
        .el-table--scrollable-y
        .el-table__body-wrapper::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 0;
        background: rgba(0, 0, 0, 0.1);
    }
    .reason {
        height: 80px;
        border: solid 1px #999;
        border-radius: 5px;
        padding: 5px;
    }
}
</style>